import structureTypes from 'common/constants/structureTypes'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import ServerPage from 'src/shared/types/server-page-interface'
import { migratePaymentButton } from 'tools/commands/migrate/paymentButton/migratePaymentButton'

export default function (page: ServerPage): [ServerPage, boolean] {
  let isChanged = false
  for (const entity of Object.values(page.content.entities)) {
    if (entity.type === structureTypes.PAYMENT_BUTTON) {
      isChanged = true
      page.content.entities[entity.id] = migratePaymentButton(
        entity as OldEntityInterface,
      )
    }
  }

  return [page, isChanged]
}
